import { CSSObject } from 'styled-components';

export function lineClamp(
  display: '-webkit-inline-box' | '-webkit-box',
  webkitLineClamp: number,
  applyOverflowStyles: boolean = false
): CSSObject {
  return {
    display: display,
    overflow: 'hidden',
    WebkitLineClamp: webkitLineClamp,
    '-webkit-line-clamp': webkitLineClamp,
    WebkitBoxOrient: 'vertical',
    '-webkit-box-orient': 'vertical',
    ...(applyOverflowStyles && {
      overflowWrap: 'break-word',
      wordBreak: 'break-all',
      textOverflow: 'ellipsis',
    }),
  };
}
